import React, { useState, useMemo, useEffect, useRef } from 'react'

import { useDispatch, useSelector } from "react-redux";
import { useGetStationSettingsQuery } from '../../../redux/services/SRC.js';
import TableGrid from "../../../Components/common/TableGrid";
import StationDetails from './StationDetails.js';

import { ReactComponent as EyeIcon } from "../../../assets/images/slotplanning/EyeIconGrey.svg";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import TableFilters from '../../../Components/common/TableGrid/TableFilters.js';
import { CallApi } from '../../../Components/common/CommonFunctions.js';
import { toast } from 'react-toastify';

const Stations = () => {

  const isMounted = useRef(false);
  const [station, setStation] = useState([]);
  const [stDetails, setStDetails] = useState(false);
  const [detailsData, setDetailsData] = useState({});
  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchStation = () => {
    CallApi({
      endPoint: 'station-handler-list',
      onSuccess: (res) => {
        const innerData = res.data.response_data;

        setStation(innerData)
      },
      onError: (msg) => toast.error(msg)
    });
  }

  useEffect(() => {
    if (isMounted.current) return;
    fetchStation()
    isMounted.current = true;
  }, [])

  const buildFilterParams = (filtersObj) => {
    const params = {};
    Object.entries(filtersObj).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "" || (Array.isArray(value) && value.length === 0)) {
        return;
      }
      if (Array.isArray(value)) {
        params[key] = JSON.stringify(value); // [187,186]
      } else {
        params[key] = value;
      }
    });
    if (Object.keys(params).length > 0) {
      params.is_filter = true;
    }
    return params;
  };

  const queryParams = useMemo(() => {
    const filterParams = buildFilterParams(filters);

    const params = {
      ...filterParams,
      // pagenum: pageDetails.pagenum,
      // pagesize: pageDetails.pagesize,
    };

    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    return params;
  }, [filters, pageDetails, sortby, tab]);

  const { data: myData, isFetching, refetch } = useGetStationSettingsQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const filtersConfig = [
    {
      type: "multiselect", field: "port_code", placeholder: "Station Filter",
      options: station?.map((item) => ({
        label: item.port_code,
        value: item.port_code,
      })) || [],
    },
  ];

  const allRows = myData?.response_data || [];

  const paginatedRows = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return allRows.slice(start, end);
  }, [allRows, currentPage, itemsPerPage]);

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: "tw-2",
      renderCell: (row) => (
        <div className="tb_grid_actions">
          <EyeIcon className="icon_dark_gray" style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleDetails(row)
            }} />
        </div>
      ),
    },
    { label: 'Stations', field: 'port_code', enableSearch: true, cls: "tw-2" },
    { label: 'Airport Name', field: 'station_name', enableSearch: true, cls: "tw-2" },
    {
      label: 'Total Address', field: 'Address', enableSearch: true, cls: "tw-2",
      renderCell: (row) => {
        return (
          <div>
            {row?.address?.length}
          </div>
        );
      },
    },
  ];

  const handleDetails = (data) => {
    setDetailsData(data)
    setStDetails(true)
  }
  const handleBack = () => {
    setDetailsData({})
    setStDetails(false)
  }

  const ItemPChange = (val) => { setItemsPerPage(val); setCurrentPage(1) }
  const currPChange = (val) => { setCurrentPage(val) }
  return (
    <>
      {stDetails ?
        <>
          <div>
            <button onClick={handleBack} className='back_set'><FontAwesomeIcon icon={faArrowLeft} /> Back</button>
            <h4>Station Details - {detailsData.port_code}</h4>
            <p>Manage the station addresses and contact information</p>
          </div>
          <hr />
          {/* <div className='d-flex justify-content-between pt-3'>
            <div>
              <h4>Manage Address </h4>
              <p>Manage Address and add address</p>
            </div>
            <div className='align-self-center'>
              <button className='add_adres'>+ Add Address</button>
            </div>
          </div> */}
          <StationDetails propData={detailsData} reload={refetch} />
        </>
        :
        <>
          <div>
            <h4>Station Settings</h4>
            <p>Manage all the stations within the network</p>
          </div>
          <hr />
          <div className="d-flex justify-content-between align-items-center mb-3">
            <TableFilters filtersConfig={filtersConfig} />
          </div>
          <div className='setting_table w-50'>
            <TableGrid
              columns={columns}
              rows={paginatedRows}
              checkboxSelection={false}
              totalRecords={myData?.response_data?.length || 0}
              // onClickRow={(row) => handleDetails(row)}
              loading={isFetching}
              rowKey='station_id'
              // bulkActions={bulkActions}
              onIPPChange={ItemPChange}
              onCPChange={currPChange}
            />
          </div>
        </>
      }

    </>
  )
}

export default Stations;